<div class="card shadow-2 mt-2">
  <div class="flex justify-content-between mb-4">
    <h5>{{ app.name }}</h5>
    <div class="flex justify-content-end gap-2">
      <!-- <p-button icon="pi pi-save" [loading]="loading[1]" (onClick)="load(1)"></p-button> -->
      <p-button icon="pi pi-eye" (onClick)="navigateToMaiDetailApp()"></p-button>
    </div>
  </div>
  <ul class="list-none p-0 m-0">
    <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
      <div class="text-500 w-6 md:w-3 font-medium">Pub key Stripe</div>
      <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
        {{ app.stripe_pub_key ?? '-' }}
      </div>
    </li>
    <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
      <div class="text-500 w-6 md:w-3 font-medium">Priv key Stripe</div>
      <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
        {{ app.stripe_pv_key ?? '-' | maskString }}
      </div>
    </li>
    <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
      <div class="text-500 w-6 md:w-3 font-medium">Jistsi server URL</div>
      <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
        {{ app.jitsi_server_url ?? '-' }}
      </div>
    </li>
    <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
      <div class="text-500 w-6 md:w-3 font-medium">Jistsi API Key</div>
      <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
        {{ app.jitsi_api_key ?? '-' | maskString }}
      </div>
    </li>
  </ul>
</div>
